// extracted by mini-css-extract-plugin
export default {"chatRoomContentDiv":"ChatRoomContent_chatRoomContentDiv__PXNoB","chatRoomContentBtn":"ChatRoomContent_chatRoomContentBtn__uU1fv"};